import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-79edb13e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container py-5" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "section-subtitle text-center mb-5" }, " Les enseignants de l’EITP sont pour la plupart détenteurs de doctorat en sciences sacrées ou en philosophie. ", -1))
const _hoisted_3 = { class: "row g-4" }
const _hoisted_4 = { class: "prof-mini-card" }
const _hoisted_5 = ["src"]
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "prof-mini-name" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.professeurs, (prof) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "col-xl-3 col-lg-3 col-md-4 col-sm-6",
          key: prof.id
        }, [
          _createElementVNode("div", _hoisted_4, [
            (prof.user?.urlImage)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  src: _ctx.getImageUrl(prof.user.urlImage),
                  alt: "Photo disciple",
                  class: "prof-photo"
                }, null, 8, _hoisted_5))
              : (_openBlock(), _createElementBlock("img", {
                  key: 1,
                  src: _ctx.defaultPhoto,
                  alt: "Photo par défaut",
                  class: "prof-photo"
                }, null, 8, _hoisted_6)),
            _createElementVNode("h5", _hoisted_7, [
              _createVNode(_component_router_link, {
                to: `/professeurs/${prof.id}`,
                class: "prof-link"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(prof.nom) + " " + _toDisplayString(prof.prenom), 1)
                ]),
                _: 2
              }, 1032, ["to"])
            ])
          ])
        ]))
      }), 128))
    ])
  ]))
}